import React, { useRef, useState } from 'react';
import './ImageUpload.css';

const ALLOWED_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/svg+xml',
];

function ImageUpload({ onUpload, loading, progress }) {
  const [dragActive, setDragActive] = useState(false);
  const fileInputRef = useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') setDragActive(true);
    else if (e.type === 'dragleave') setDragActive(false);
  };

  const takeFiles = (fileList) => {
    const files = Array.from(fileList || []);
    const valid = files.filter((file) => ALLOWED_TYPES.includes(file.type) && file.size <= 50 * 1024 * 1024);
    if (valid.length === 0) {
      alert('Use JPEG, PNG, GIF, WebP, or SVG · max 50MB each');
      return;
    }
    onUpload(valid);
  };

  return (
    <div className="image-upload">
      <div
        className={`drop-zone ${dragActive ? 'active' : ''} ${loading ? 'loading' : ''}`}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={(e) => {
          e.preventDefault();
          setDragActive(false);
          takeFiles(e.dataTransfer.files);
        }}
        onClick={() => !loading && fileInputRef.current?.click()}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            fileInputRef.current?.click();
          }
        }}
      >
        <input
          ref={fileInputRef}
          type="file"
          accept={ALLOWED_TYPES.join(',')}
          multiple
          onChange={(e) => {
            takeFiles(e.target.files);
            e.target.value = '';
          }}
          className="file-input"
          disabled={loading}
        />
        <div className="drop-zone-inner">
          <p className="drop-kicker">Drop originals</p>
          <p className="drop-title">
            {loading && progress
              ? `Uploading ${progress.current} / ${progress.total}`
              : loading
                ? 'Uploading…'
                : 'Drop images here, or click to browse'}
          </p>
          <p className="drop-hint">JPEG · PNG · WebP · GIF · SVG · 50MB each · multiple files</p>
        </div>
      </div>
    </div>
  );
}

export default ImageUpload;
